module.exports = __webpack_public_path__ + "static/media/JN-foundation-horizontal.766f4658.png";